import { Component, OnInit, Input, OnChanges, ChangeDetectionStrategy, ChangeDetectorRef } from '@angular/core';
import { SharedService } from '@myproject/shared/shared.service';
import { environment } from '@myenv/environment';
import { configMessage } from '@shared/config-message';
import { DatePipe } from '@angular/common';
import { SecondsToHmsPipe } from '@myproject/shared/seconds-to-hms.pipe';
import { OtaService } from '@myproject/components/central-ota/ota.service';
import * as FileSaver from 'file-saver';
import { finalize } from 'rxjs/operators';

@Component({
    selector: 'app-device-activity',
    templateUrl: './device-activity.component.html',
    styleUrls: ['./device-activity.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class DeviceActivityComponent implements OnInit, OnChanges {
  public dateFormat = environment.smallDateFormat;
  public isoDateFormat = environment.isoDateTimeFormat;
  failStatus = configMessage.campaignStageFailStatus;
  @Input() campaignId!: string;
  @Input() campaignName!: string;
  @Input() showModal!: boolean;
  @Input() hideModal!: boolean;
  @Input() device: any = {};
  deviceHistory: any[] = [];
  deviceHistoryView: any[] = [];
  isLoading = false;
  loadmore = false;
  pager = {
    page: 1,
    startIndex: 0,
    endIndex: 99,
    numberOfItems: 100,
    totalItems: 0
  };
  type: any;

  constructor(
    private sharedService: SharedService,
    private otaService: OtaService,
    private secondsToHms: SecondsToHmsPipe,
    private cdr: ChangeDetectorRef,
  ) { }

  ngOnInit() {
    const productType = JSON.parse(localStorage.getItem('currentUser') || '{}').productType;
    this.type = (productType || '').toLowerCase();
  }

  ngOnChanges(changes: any) {
    // Show Modal
    if (changes.showModal && changes.showModal.previousValue !== undefined) {
      if (changes.showModal.previousValue !== changes.showModal.currentValue) {
        document.getElementById('historyModalBtn')!.click();
        this.deviceHistory = [];
        this.deviceHistoryView = [];
        this.getDeviceHistory();
      }
    }
    // Hide Modal
    if (changes.hideModal && changes.hideModal.previousValue !== undefined) {
      if (changes.hideModal.previousValue !== changes.hideModal.currentValue) {
        document.getElementById('closeHistoryModal')!.click();
      }
    }
  }

  getDeviceHistory() {
    this.isLoading = true;
    this.cdr.detectChanges();
    const data = {
      campaignId: this.campaignId,
      createdAt: this.device.createdAt,
      serialNumber: this.device.serialNumber
    };

    const service = this.type === 'bitbrew'
      ? this.otaService.getDeviceHistory(data)
      : this.otaService.getV2DeviceHistory(data, this.type);

    service.pipe(
      finalize(() => {
        this.isLoading = false;
        this.cdr.detectChanges();
      }),
    ).subscribe({
      next: res => {
        this.deviceHistory = Array.isArray(res) ? res : [];
        this.pager.totalItems = this.deviceHistory.length;
        this.paginate(1);
        this.cdr.detectChanges();
      },
      error: error => {
        this.deviceHistory = [];
        this.deviceHistoryView = [];
        this.sharedService.getErrorMsg(error);
      }
    });
  }

  paginate(page: number) {
    const endIndex = page * this.pager.numberOfItems;
    if (this.pager.totalItems > 100 && endIndex <= this.pager.totalItems) {
      this.loadmore = true;
      this.pager.page = page;
      this.pager.endIndex = endIndex;
      this.deviceHistoryView = this.deviceHistory.slice(this.pager.startIndex, this.pager.endIndex - 1);
    } else {
      this.loadmore = false;
      this.deviceHistoryView = this.deviceHistory;
    }
  }

  loadMoreActivity() {
    this.pager.page++;
    this.paginate(this.pager.page);
  }

  // displayTooltip(data): Object {
  //   if (data.errorCode || data.remark) {
  //     return { display: true };
  //   } else {
  //     return { display: false };
  //   }
  // }

  // tooltipContent(data): string {
  //   const status = this.failStatus[data.errorCode] ? this.failStatus[data.errorCode] : 'NA';
  //   if (data.errorCode && data.remark) {
  //     return `Error: ${status}<br>Remark: ${data.remark}`;
  //   } else if (data.errorCode && !data.remark) {
  //     return `Error: ${status}`;
  //   } else if (!data.errorCode && data.remark) {
  //     return `Remark: ${data.remark}`;
  //   } else {
  //     return `No Data`;
  //   }
  // }

  exportActivityCSV() {
    const dh = [
      'Campaign Name', 'Serial Number', 'Schedule At',
      'Updated At', 'Completed At', 'Stage',
      'Status', 'Processed In', 'Scheduled By', 'Cancelled By'
    ];
    const headers = [
      'campaignName', 'serialNumber', 'scheduleAt',
      'updatedAt', 'completedAt', 'stage',
      'status', 'totalTime', 'scheduledBy', 'cancelledBy'
    ];
    const tempHistory = JSON.parse(JSON.stringify(this.deviceHistory));
    const filename = `${this.campaignName}_Device_Activity`;
    const data = tempHistory.map((device: any) => {
      return headers.map(header => {
        if (header === 'campaignName') {
          device[header] = this.campaignName;
        }
        if (header === 'scheduleAt' || header === 'updatedAt' || header === 'completedAt') {
          const datePipe = new DatePipe('en-US');
          device[header] = datePipe.transform(device[header], this.isoDateFormat);
        }
        if (header === 'totalTime' && device[header]) {
          device[header] = this.secondsToHms.transform(device[header], 'milliseconds');
        }
        if (header === 'stage' && device[header]) {
          device[header] = `Stage ${device[header]}`;
        }
        return device[header] || '';
      });
    });
    const escapeCsv = (value: any) => `"${String(value).replace(/"/g, '""')}"`;
    const csvRows = [
      dh.map(escapeCsv).join(','),
      ...data.map((row: unknown[]) => row.map(escapeCsv).join(','))
    ];
    const blob = new Blob([csvRows.join('\n')], { type: 'text/csv;charset=utf-8;' });
    FileSaver.saveAs(blob, filename);
  }

  onClose() {
    this.deviceHistory = [];
    this.deviceHistoryView = [];
    this.loadmore = false;
    this.pager = {
      page: 1,
      startIndex: 0,
      endIndex: 99,
      numberOfItems: 100,
      totalItems: 0
    };
  }

  displayTooltip(data: any): Object {
    if (data.errorCode || data.remark) {
      return {display: true};
    } else {
      return {display: false};
    }
  }

  tooltipContent(data: any): string {
    const status = this.failStatus[data.errorCode] ? this.failStatus[data.errorCode] : 'NA';
    if (data.errorCode && data.remark) {
      return `Error: ${status}<br>Remark: ${data.remark}`;
    } else if (data.errorCode && !data.remark) {
      return `Error: ${status}`;
    } else if (!data.errorCode && data.remark) {
      return `Remark: ${data.remark}`;
    } else {
      return `No Data`;
    }
  }
}
